/**
 * analytics — product events, deliberately a no-op for now.
 *
 * Phase 8 decided (Q1, 2026-09-22) to defer choosing an analytics tool while the
 * team works on the store apps. The new creator still calls track() at every
 * step, so wiring a provider later is a change to this file only. When that
 * happens, prefer a cookieless tool, or gate on the existing cookie consent.
 *
 * Events the creator emits: creator_started, step_viewed {step},
 * clue_added {n}, celebration_chosen {type}, seal_chosen {on},
 * publish_succeeded {clues, sealed, theme, finale}, publish_failed {code}.
 */
import logger from "./logger";

export function track(event, props = {}) {
  logger.debug("track", { event, ...props });
}

export default { track };
